import { Link } from "react-router-dom";
import StatusBadge from "./StatusBadge";

interface EventLike {
  id: string;
  title: string;
  category: string;
  status: string;
  summary: string;
  cover: string;
  tags: string[];
  publishedAt: string;
  updatedAt: string;
}

interface EventCardProps {
  event: EventLike;
}

export default function EventCard({ event }: EventCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/events/${event.id}`} className="block">
        <div className="h-44 w-full overflow-hidden bg-background-100">
          <img
            src={event.cover}
            alt={`${event.title} 官方通报时间线配图`}
            title={`${event.title} · 网报吃瓜时间线`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-3 flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center rounded-md bg-background-200/80 px-2 py-0.5 text-xs font-medium text-foreground-700">
            {event.category}
          </span>
          <StatusBadge status={event.status} />
        </div>
        <h3 className="mb-2 font-heading text-base font-bold leading-snug text-foreground-950">
          <Link to={`/events/${event.id}`} className="transition-colors hover:text-accent-600">
            {event.title}
          </Link>
        </h3>
        <p className="mb-4 line-clamp-3 text-sm leading-relaxed text-foreground-600">
          {event.summary}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-1.5">
          {event.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100/80 px-2.5 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span>更新于 {event.updatedAt}</span>
          <span className="inline-flex items-center gap-1 font-medium text-primary-700">
            查看时间线
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}